import React, { useState } from "react";

const AdditionalNotes = () => {
  const [formData, setFormData] = useState({
    patient_issues: "",
    suggestions: "",
  });

  const [isUpdating, setIsUpdating] = useState(false);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleUpdate = () => {
    setIsUpdating(true);

    setTimeout(() => {
      setIsUpdating(false);
    }, 1000);
  };

  return (
    <>
      <div className="flex justify-between items-center mb-6"></div>

      <div className="grid grid-cols-1 gap-6">
        {/* Patient Issues */}
        <div>
          <label className="block font-medium mb-1">
            1. Issues faced by patients
          </label>
          <textarea
            rows={4}
            className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={formData.patient_issues}
            onChange={(e) => handleChange("patient_issues", e.target.value)}
            placeholder="Write issues here..."
          />
        </div>

        {/* Suggestions */}
        <div>
          <label className="block font-medium mb-1">
            2. Any suggestion to improve HF services
          </label>
          <textarea
            rows={4}
            className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={formData.suggestions}
            onChange={(e) => handleChange("suggestions", e.target.value)}
            placeholder="Write suggestions here..."
          />
        </div>
      </div>

      <div className="mt-8 flex justify-end">
        <button
          type="button"
          onClick={handleUpdate}
          disabled={isUpdating}
          className={`${
            isUpdating
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-teal-600 hover:bg-teal-700"
          } text-white px-4 py-2 rounded-lg transition duration-200 font-medium`}
        >
          {isUpdating ? "Updating..." : "Update"}
        </button>
      </div>
    </>
  );
};

export default AdditionalNotes;
